import SaleUtils from '@/services/SaleUtils'
import { required } from "@/services/validations"
// Fields to Comercial Information
export default [
    {
        //comercial fields[0] - Precio Costo
      name: 'cost_price',
	    format: 'currency-field',
      type: 'currency-field',
      flex: {
        sm6: true,
        lg4: true,
      },
      props: {
          label: 'Precio Costo $',
          rules: [required],
          suffix : '',
      },
      trigger: (ctx)=>{
        
        //set margin value
        if(ctx.value.sale_price && ctx.value.cost_price  ){
          ctx.value.gains_margin = SaleUtils.getNewMargin(ctx.value.sale_price, ctx.value.cost_price)
        }
      }
    },
    {
      //comercial fields[1] - Precio Venta
      name: 'sale_price',
      format: 'currency',
      type: 'currency-field',
      flex: {
        sm6: true,
        lg4: true,
      },
      props: {
          label: 'Precio Venta $',
          rules: [required],
          suffix: '',
      },
      trigger: (ctx)=>{
        //set net price
        ctx.value.net_price = SaleUtils.getNetPrice(ctx.value.sale_price)
        //set margin value
        if(ctx.value.sale_price && ctx.value.cost_price  ){
          ctx.value.gains_margin = SaleUtils.getNewMargin(ctx.value.sale_price, ctx.value.cost_price)
        }

      }
    },
    {
      //comercial fields[3]
      name: 'warranty_days',
      type: 'currency-field',
      props: {
          label: 'Garantía (días)',
          mask: '####',
          rules: [required],
          suffix: '',
      },
  },
  //   {
  //     name: "internal_code",
  //     type: "text-field",
  //     flex: {
  //         sm6: true,
  //         lg3: true,
  //     },
  //     props: {
  //         label: "Código interno",
  //         rules: [ required ],
  //     },
  // },
    
    {
        //comercial fields[1] - Precio Venta
        name: 'net_price',
        type: 'currency-field',
        flex: {
          sm6: true,
          lg4: true,
        },
        props: {
            label: 'Precio Neto $',
            readonly: true,
            suffix: '',
        },
        rules: [],
        // computed: ({ sale_price }) => {
        //     return '$' + SaleUtils.getNetPrice(sale_price)
        // },
    },
    {
        //comercial fields[2] - Margen
        name: 'gains_margin',
        type: 'text-field',
        flex: {
          sm6: true,
          lg4: true,
        },
        props: {
          label: 'Margen',
          suffix: '%',
          readonly: true,
        },
        rules: [],
        // computed: ({ sale_price, cost_price }) =>
        //     SaleUtils.getNewMargin(sale_price, cost_price),
        // value: 0,
    },
    
    {
        props: {title:''},
        type: 'section-field',
        flex: {
          xs12: true,
        },
    },
    {
        //comercial fields[4] - Producto Vendible
        name: 'is_salable',
        type: 'checkbox',
        flex: {
          sm6: true,
          lg4: true,
        },
        props: {
            label: 'Producto Vendible',
            'false-value': false,
        },
        value: false,
    },
    {
        //comercial fields[5] - Producto libre de impuestos
        name: 'is_tax_free',
        type: 'checkbox',
        flex: {
          sm6: true,
          lg4: true,
        },
        props: {
            label: 'Producto Libre de Impuesto',
        },
        value: false,
    },
    {
        //comercial fields[6] - Producto consumo interno
        name: 'is_consumable',
        type: 'checkbox',
        props: {
            label: 'Producto Consumo Interno',
            'false-value': false,
        },
        value: false,
    },
]
